let scheduleFn = setTimeout;

function delay(timeoutMilliseconds) {
  let timerId;
  let reject;
  let p = new Promise((res, rej) => {
    reject = rej;
    timerId = scheduleFn(res, timeoutMilliseconds);
  });
  p.cancel = () => {
    clearTimeout(timerId);
    reject(new Error('Cancelled'));
  };

  return p;
}

export default delay;

function _setScheduler(schedule) {
  scheduleFn = schedule;
}

export { _setScheduler };
